import styled, { css, keyframes } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, ColorPalette } from '@optimus-web/local-tokens';
import { LoaderMode } from './types';

export const CircleLoaderWrapper = styled.svg`
    box-sizing: content-box;
`;

export const CircleLoaderTrack = styled.circle`
    stroke: ${ColorPalette.COLOR_NIGHT_200};
`;

const spin = keyframes`
    0% {
        transform: rotate(-90deg);
    }
    100% {
        transform: rotate(270deg);
    }
`;

export const CircleLoaderIndicator = styled.circle`
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
    stroke: ${ColorPalette.COLOR_INDIGO_500};
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-property: stroke-dasharray;
    transition-timing-function: ${ANIMATION_CURVE.default};

    ${(props) =>
        props.mode === LoaderMode.Indeterminate &&
        css`
            animation: ${spin} 1s linear infinite;
        `}
`;
